module.exports = __webpack_public_path__ + "static/media/croatia.bf87b786.png";